module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// /deploy/www/v2/sa/app/emr-webapp/~/readable-stream/writable-browser.js
// module id = ../../../../readable-stream/writable-browser.js
// module chunks = 5